var Validate = require('./validate');

var Model = {};

Model.validate = function (data) {
  var self = this;
  var formData = {};
  var validators = {};

  Object.keys(self.fields).forEach(function (key) {
    validators[key] = self.fields[key]['validators'];
    formData[key] = data[key].toJSON();
  });

  return Validate.async(formData, validators, {format: 'flat'})
};

module.exports = Model;
